import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import './Slide.scss';
import axios from '../../lib/AxiosInstance';
import reducerStore from '../../reducers/reducerStore';
import Widget from '../Widgets/Widget';
import HeaderWidget from '../Widgets/HeaderWidget';
import colorHelper from '../../lib/colorLuminance';

const WidthProvider = require('react-grid-layout').WidthProvider;
let ReactGridLayout = require('react-grid-layout');

ReactGridLayout = WidthProvider(ReactGridLayout);

class CompetitionSlide extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			rowHeight: 2,
			containerWidth: 0
		}

		this.widgetSizes = {
			ColumnChartWidget: {
				w: 14,
				h: 10
			}
		}
	}

	static generateCompetitionWidgets(rowHeight) {

		const list = [
			{
				displayConfig: { customTitle: 'Top score' },
				displayType: 'CompetitionTopListWidget',
				y: 4, x: 3,
				height: 15, width: 11,
				dataConfig: {
					include: {
						type: 'all',
						role: []
					},
					period: 'currentMonth',
					dividedBy: 'user'
				}
			},
			{
				displayConfig: { customTitle: 'Tävlingsmål' },
				displayType: 'CompetitionGoalWidget',
				y: 4, x: 14,
				height: 4, width: 7,
				dataConfig: {
					include: {
						type: 'all',
						role: []
					},
					period: 'currentMonth',
					dividedBy: 'user'
				}
			},
			{
				displayConfig: { customTitle: 'Tid Kvar' },
				displayType: 'CompetitionTimeLeftWidget',
				y: 8, x: 14,
				height: 4, width: 7,
				dataConfig: {
					include: {
						type: 'all',
						role: []
					},
					period: 'currentMonth',
					dividedBy: 'user'
				}
			},
			{
				displayConfig: { customTitle: 'Bäst idag' },
				displayType: 'CompetitionBestTodayWidget',
				y: 12, x: 14,
				height: 7, width: 7,
				dataConfig: {
					include: {
						type: 'all',
						role: []
					},
					period: 'currentMonth',
					dividedBy: 'user'
				}
			},
			{
				displayConfig: { customTitle: '' },
				displayType: 'CompetitionCriteriasWidget',
				y: 19, x: 3,
				height: 5, width: 18,
				dataConfig: {
					include: {
						type: 'all',
						role: []
					},
					period: 'currentMonth',
					dividedBy: 'user'
				}
			}
		];

		return list;
	}

	generateLayout(widgets, isThumbnail, isPlaying) {
		const layout = widgets.map(widget => ({
			i: widget._id,
			x: widget.x,
			y: widget.y,
			w: widget.width,
			h: widget.height,
			static: true,
		}));

		return layout;
	}

	generateCompanyProfile(companyProfile) {
		if (!companyProfile) {
			return null;
		}

		return {
			background: colorHelper.colorLuminance(companyProfile.colors.mainBg, 0)
		}
	}

	makeSlideStyle(color) {
		return {
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			zIndex: '0',
			background: `linear-gradient(
				135deg,
				${colorHelper.convertHex(colorHelper.colorLuminance(color, -0.4), 90)},
				${colorHelper.convertHex(colorHelper.colorLuminance(color, -0.6), 99)}
			)`,
		}
	}

	makeSlideOverlayStyle(bgImage, opacity) {
		if (!bgImage) {
			return null;
		}

		return {
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			backgroundImage: `url('${bgImage}')`,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center center',
			opacity: opacity,
			zIndex: '0',
		}
	}

	componentDidMount() {
		const { isThumbnail, offsetHeight, parent } = this.props;
		const rowHeight = isThumbnail ? 2 : ((parent.offsetHeight - 10) / 24) - 10;
		const containerWidth = parent.offsetWidth;

		this.setState({
			containerWidth,
			rowHeight
		});
	}

	getSlideTitle(name, minDate, maxDate) {
		let startDay = moment(minDate).format('D');
		let startingMonth = moment(minDate).format('MMMM');
		let endDay = moment(maxDate).format('D');
		let endingMonth = moment(maxDate).format('MMMM');

		let contestName = `${name} : ${startDay} ${startingMonth} - ${endDay} ${endingMonth}`;
		return contestName;
	}

	render() {
		const { slide, slidesData, startEditing, active, isPlaying, isThumbnail, companyProfile, currency } = this.props;
		const { rowHeight, containerWidth } = this.state;
		const colorprofile = this.generateCompanyProfile(companyProfile);
		moment.locale('en-gb');

		if (!active) return null;

		const _widgets = [].concat(this.constructor.generateCompetitionWidgets(rowHeight));
		const widgetData = slidesData ? slidesData[slide.id] : null;
		const widgets = slide.widgets.map((widget) => {
			//widget.dataConfig = {};
			return <div className="box" style={colorprofile} key={widget._id}>
				<Widget
					rowHeight={rowHeight}
					widget={widget}
					widgetData={widgetData}
					currency={currency}
					key={widget._id}
					isPlaying={isPlaying}
					startEditing={startEditing}
					slideId={slide._id}
					companyProfile={companyProfile}
					isThumbnail={isThumbnail}
					isCompetition={true}
					slide={slide}
				/>
			</div>
		});

		const layout = this.generateLayout(slide.widgets, isThumbnail, isPlaying);

		if (!isThumbnail) {
			layout.unshift({
				i: 'header',
				x: 0,
				y: 0,
				w: 24,
				h: 3,
				static: true,
			});

			let headerLogoImage = '';
			if (slide.showCompanyLogo && slide.custom && slide.custom.logo) {
				headerLogoImage = slide.custom.logo;
			} else if (slide.showCompanyLogo) {
				headerLogoImage = companyProfile.logo;
			}

			let slideTitle = this.getSlideTitle(slide.competitionSettings.name,
				slide.competitionSettings.minDate || moment(),
				slide.competitionSettings.maxDate || moment());

			widgets.unshift(
				<div key="header">
					<HeaderWidget
						headerType={'text'}
						headerValue={slideTitle}
						showCompanyLogo={slide.showCompanyLogo}
						headerLogoImage={headerLogoImage}
						isCompetition={true}
						customColor={slide.custom.bgColor}
					/>
				</div>
			)
		} else {
			// Move widgets up to take place of unused header
			_.each(layout, (l) => {
				const x = this.props.isChannelThumbnail ? 1.5 : 2;
				// const min = Math.min(l.w, l.h);
				l.h = l.h / x;
				l.y = (l.y / x) - 1;
				// l.w = Math.ceil(l.w / min);
				l.minH = l.h;
				// l.minW = l.w;
				//l.y = l.y - 2;
			});
		}

		const className = active ? 'layout' : 'layout hide';
		const wrapperClassNames = active ? 'show' : 'show hide';

		const color = slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg;
		const opacity = slide.custom && slide.custom.bgOpacity ? (slide.custom.bgOpacity / 100) : '0.9';

		const slideOverlayStyle = this.makeSlideOverlayStyle(slide.backgroundImage, opacity);
		const slideStyle = this.makeSlideStyle(color);

		return (
			<div ref={node => this.node = node} className={wrapperClassNames} style={slideStyle}>
				<div className="overlayHolder" style={slideOverlayStyle} />
				<ReactGridLayout
					className={className}
					layout={layout}
					ref={slide._id}
					cols={24}
					rowHeight={rowHeight}
					width={containerWidth}
					maxRows={24}
				>
					{widgets}
				</ReactGridLayout>
			</div>
		);
	}
}

export default CompetitionSlide;


/** WEBPACK FOOTER **
 ** ./client/components/Slide/CompetitionSlide.jsx
 **/